// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#student-footer {
  background-color: #00375d;
  border: 1px solid #0579ab;
  color: white;
  padding: 20px;
}

#student-footer #footer-message {
  font-family: Rockwell, Verdana, Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 15px;
}

#student-footer button {
  border: 2px solid #1eabe3;
  color: #1eabe3;
  align-content: center;
  background-color: white;
  font-size: 14px;
  padding: 0.4em 0.6em 0.4em 0.6em;
}

.center-this {
  display: flex;
  justify-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/studentui/studentFooter.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iDAAiD;EACjD,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":["#student-footer {\n  background-color: #00375d;\n  border: 1px solid #0579ab;\n  color: white;\n  padding: 20px;\n}\n\n#student-footer #footer-message {\n  font-family: Rockwell, Verdana, Arial, sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  text-align: center;\n  margin-bottom: 15px;\n}\n\n#student-footer button {\n  border: 2px solid #1eabe3;\n  color: #1eabe3;\n  align-content: center;\n  background-color: white;\n  font-size: 14px;\n  padding: 0.4em 0.6em 0.4em 0.6em;\n}\n\n.center-this {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
